/**
 * 支払方法変更マスタ反映_おしらせ通知API
 * レスポンス - レスポンス業務エリア
 */

export interface Sgkd005aResponseDto {
  /** 受付番号 */
  aceptNo?: string;
  /** 請求お客さま番号 */
  recptFixNo?: string;
}
